var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useSelector, useDispatch } from "react-redux";
import { setVenues } from "../../store/reducers/venuesSlice";
import { setVenue } from "../../store/reducers/venueSlice";
import { MapKeys, MAP_STATUS, GLOBAL_MAP_DETIALS, } from "../../store/common/constants";
import utils from "../../store/helpers/indoorHelper";
import { useUserInfo } from "./userInfo";
export var useGlobalVenueState = function () {
    var VenueDetails = useSelector(function (state) { return state.venues; });
    var currentVenue = useSelector(function (state) { var _a; return (_a = state === null || state === void 0 ? void 0 : state.venue) === null || _a === void 0 ? void 0 : _a.venue; });
    var dispatch = useDispatch();
    var locale = useUserInfo().locale;
    /**
     * This will update the venue state to the current state
     * @param venues
     */
    var updateCurrentVenue = function (venues) {
        if (utils.isEmpty(VenueDetails) && utils.isEmpty(VenueDetails.list)) {
            return [];
        }
        var newVenues = VenueDetails.list.map(function (v) {
            if (v.id === currentVenue.id) {
                return __assign(__assign({}, v), { isDraft: true, draftStatus: MAP_STATUS[MapKeys.CHECKED_OUT].LABEL, modified: utils.formattedDate(locale, new Date()), buttonText: GLOBAL_MAP_DETIALS.EDIT_MAP, state: MAP_STATUS[MapKeys.PENDING_UPDATE].LABEL });
            }
            return v;
        });
        var updateVenueDetails = __assign(__assign({}, venues), { isDraft: true, draftStatus: MAP_STATUS[MapKeys.CHECKED_OUT].LABEL, modified: utils.formattedDate(locale, new Date()), state: MAP_STATUS[MapKeys.PENDING_UPDATE].LABEL });
        //this will update the current venue state and global venue listing information
        dispatch(setVenue(__assign({}, updateVenueDetails)));
        dispatch(setVenues(newVenues));
        return null;
    };
    return __assign(__assign({}, VenueDetails), { updateCurrentVenue: updateCurrentVenue });
};
